import { Page } from 'layouts/Page';
import { FC } from 'react';
import { ProductType } from 'components/ProductType';

export const ProductTypePage: FC = () => {
	return (
		<Page title="EAS GPSR Database">
			<ProductType />
		</Page>
	);
};
